import React, {Component} from 'react'
import { getProfileMenuItems, getYettelMenuItems} from "../../helpers/loginInfo";
import HeaderProfilePopupContent from "./headerProfilePopup/headerProfilePopupContent";
import Language from './Language'
import List from './List'
import MobileHead from './MobileHead'
import MobileMenu from './MobileMenu'
import MobileList from './MobileList'
import close from './img/close.png'
import PropTypes from 'prop-types'
import { getLanguageFromUrl, getSectionFromUrl } from '../../helpers/util';
import './css/scss/header.scss'

class MobileHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showLogin: false,
      showYettelApps: false,
      showMenu: false,
    }
  }

  showMenu = () => {
    this.hideLogin()
    this.setState({showMenu: true})
  }

  hideMenu = () => {
    this.setState({ showMenu: false, showYettelApps: false })
  }

  hideLogin = () => {
    this.setState({showLogin: false})
  }

  showLogin = () => {
    this.state.activeItemSecondLevelMenu !== 0 && this.setState({activeItemSecondLevelMenu: 0})
    this.setState({showLogin: true, showYettelApps: false });
  }

  showYettelApps = () => {
    this.setState({ showYettelApps: true, showMenu: true, showLogin: false });
  }

  hideYettelApps = () => {
    this.setState({ showYettelApps: false, showMenu: false })
  }

  render() {
    const activeItemFirstLevelMenu = this.props.activeItemFirstLevelMenu
    const header = this.props.pageShell.data.header;
    const consumer = header.consumer;
    const business = header.business;
    const about = header.about;
    const bank = header.bank;
    const menu = [consumer, business, bank, about];
    const loginInfo = this.props.session;
    const profileMenuItem = getProfileMenuItems();
    const yettelMenuItems = getYettelMenuItems();
    const numberOfOrderItems = loginInfo.numberOfOrderItems;
    let isLoggedIn = Boolean(loginInfo.user);
    const isConsumer = getSectionFromUrl() === "consumer";
    const language = getLanguageFromUrl();
    return (
      <div id="mobile-menu">
        <MobileHead setShouldCallLogin={this.props.setShouldCallLogin} cookie={this.props.cookie} menuVisibility={this.state.showMenu} handleShowMenu={this.showMenu} handleCloseMenu={this.hideMenu}
                    showLogin={this.state.showLogin} isLoggedIn={isLoggedIn} handleLoginClick={this.showLogin}
                    numberOfOrderItems={numberOfOrderItems} showYettelApps={this.state.showYettelApps} handleYettelAppsClick={this.showYettelApps} language={this.props.language}
                    section={this.props.section} />
        {this.state.showLogin ?
          <MobileMenu show={this.state.showLogin}>
            <div>
              <HeaderProfilePopupContent hideSubmenu={this.hideLogin} item={profileMenuItem}/>
            </div>
          </MobileMenu> :
          <MobileMenu show={this.state.showMenu}>
            {this.state.showYettelApps ?
            <>
              <div className={'pt-3 pb-3 pr-3'}>
                <div className={'offset-9 col-sm-3 col-3 p-3'}>
                  <img alt={'close'} src={close} className={'icon mx-auto d-block pull-right'} onClick={this.hideYettelApps}/>
                </div>
              </div>
              <div>
                <List list={yettelMenuItems} activeItem={this.state.showLogin} level={'mobile-third-level'}/>
              </div>
            </>
          : <>
            <>
              <div className={'py-2 px-4 d-inline-block'}>
                <Language activeLanguage={this.props.language}/>
              </div>
              {isConsumer && language === "sr" && (
                    <div className={'float-end me-3 mt-2 pe-3 d-inline-block'}>
                      <a
                        style={{ color: '#002340' }}
                        className="no-child list-item first-level"
                        href="https://www.yettel.rs/sr/privatni/podrska"
                      >
                        <span> Kontakt i Podrška </span>
                      </a>
                    </div>
                  )}
              </>
              <div className={'container mb-4 mt-2'}>
                <MobileList list={menu} activeItem={activeItemFirstLevelMenu} level={'first-level'}
                      handleClose={this.hideMenu} numberOfOrderItems={numberOfOrderItems}
                      language={this.props.language}/>
              </div>
            </>}
          </MobileMenu>
        }
      </div>
    )
  }
}

MobileHeader.propTypes = {
  language: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired,
  pageShell: PropTypes.object.isRequired,
  cookie: PropTypes.object.isRequired,
  session: PropTypes.object.isRequired,
}

export default MobileHeader
